import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef, useState, useCallback } from "react";
import { useLang } from "@/common/Contexts/LanguageContext";
var Camera360New = function Camera360New(props) {
  var changingContentRef = useRef();
  var _useState = useState(false),
    show360 = _useState[0],
    setShow360 = _useState[1];
  var lang = useLang();
  var cleanup360Script = function cleanup360Script() {
    var scriptTag = document.querySelector("script[data-spin=\"".concat(props.id, "\"]"));
    if (scriptTag) {
      scriptTag.remove();
    }
  };
  var handleHTMLChange = useCallback(function () {
    setShow360(true);
  }, []);
  useEffect(function () {
    if (changingContentRef.current) {
      tryScript();
      changingContentRef.current.addEventListener("DOMSubtreeModified", handleHTMLChange);

      // Clean up on route change
      window.addEventListener('beforeunload', cleanup360Script);
      return function () {
        var _changingContentRef$c;
        changingContentRef === null || changingContentRef === void 0 ? void 0 : (_changingContentRef$c = changingContentRef.current) === null || _changingContentRef$c === void 0 ? void 0 : _changingContentRef$c.removeEventListener("DOMSubtreeModified", handleHTMLChange);
        cleanup360Script();
        window.removeEventListener('beforeunload', cleanup360Script);
      };
    }
  }, []);
  useEffect(function () {
    var observer = new MutationObserver(function () {
      var spin360Hitbox = document.querySelector(".spin360-hitbox");
      var hideBtnNo360 = document.querySelector("#hideBtnNo360");
      var hideBtnNo360Mobile = document.querySelector("#hideBtnNo360Mobile");
      if (spin360Hitbox) {
        props.updateHas360(true);
        if (hideBtnNo360) hideBtnNo360.style.display = "flex";
        if (hideBtnNo360Mobile) hideBtnNo360Mobile.style.display = "flex";
      } else {
        if (hideBtnNo360) hideBtnNo360.style.display = "none";
        if (hideBtnNo360Mobile) hideBtnNo360Mobile.style.display = "none";
      }
    });
    observer.observe(changingContentRef.current, {
      childList: true,
      subtree: true
    });
    return function () {
      observer.disconnect();
    };
  }, [show360]);
  var tryScript = function tryScript() {
    cleanup360Script(); // Clean up any existing script before adding new one
    var scriptTag = document.createElement("script");
    scriptTag.type = "text/javascript";
    scriptTag.src = "https://static.instavid360.com/p/0.8.latest/spin360.lite.js";
    scriptTag.setAttribute("data-spin", "".concat(props.id));
    scriptTag.setAttribute("data-quality", "h");
    scriptTag.setAttribute("data-lang", "".concat(lang));
    scriptTag.setAttribute("data-gallery", "off");
    scriptTag.setAttribute("data-metrics", "0");
    document.getElementById("spin-div").appendChild(scriptTag);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "hideMeIfNoData",
    dir: "ltr"
  }, /*#__PURE__*/React.createElement("div", {
    id: "spin-div",
    ref: changingContentRef
  })));
};
export default Camera360New;